import { styled, useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface IContentProps {
  children: JSX.Element | null;
}

const Content: React.FC<IContentProps> = ({ children }) => {
  const theme = useTheme();
  return (
    <Stack
      component="main"
      sx={{
        flex: 1,
        minHeight: '100vh',
        backgroundColor: theme.custom.palette.primary.background,
      }}
    >
      <DrawerHeader />
      {children}
    </Stack>
  );
};

export default Content;
